export default __webpack_public_path__ + "static/media/icon_skill_add.dbb1c8a9.png";